/**
 * Returns true when `pathname` corresponds to a WMS (warehouse management
 * system) page. Feature onboarding popups and merchant-facing banners should
 * be suppressed on these routes so warehouse workers are not interrupted.
 */
export function isWmsRoute(pathname: string): boolean {
  return (
    pathname.includes("/warehouse") ||
    pathname.includes("/pick-sessions") ||
    pathname.includes("/create-pick-session") ||
    pathname.includes("/personalized-slips") ||
    pathname.includes("/wms/")
  );
}
